import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly isBGWhite = new BehaviorSubject<boolean>(false);
  public checkBGWhite = this.isBGWhite.asObservable();

  private readonly isBGColored = new BehaviorSubject<boolean>(false);
  public checkBGColored = this.isBGColored.asObservable();

  setBGWhite() {
    this.isBGWhite.next(true);
  }
  resetBGWhite() {
    this.isBGWhite.next(false);
  }
  setBGColored() {
    this.isBGColored.next(true);
  }
  resetBGColored() {
    this.isBGColored.next(false);
  }
}
